export class Proxy{
	ref: string;
	name: string;
	lastActivity: Date;
	state: 'actif' | 'error' | 'removed';
}